module.exports = __webpack_public_path__ + "img/cp-order-history.svg";